import { createContext } from 'react';

import type { OrganizationContextType } from './organization-types';

/**
 * The context object itself, apart from `useOrganization`, so a reader that must tolerate a
 * missing provider (the office type read by 84 gate call sites and by label hooks) does not depend
 * on a module that tests replace wholesale. `organization-context` re-exports it.
 */
export const OrganizationContext = createContext<OrganizationContextType | undefined>(undefined);
